"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react');






var _actions = require('shared/actions'); var _actions2 = _interopRequireDefault(_actions);




var _broadcastTemplateTokens = require('shared/services/broadcastTemplateTokens');

const GATE_CHECK_DELAY_MS = 400

/* The launch gate over the unsaved message, re-run shortly after each edit.
 * Null until the first result arrives. */








 const useGateCheck = (
  campaignKey,
  template,
  messageType,
) => {
  const [checked, setChecked] = _react.useState



(null)
  _react.useEffect.call(void 0, 
    () => {
      let isCurrent = true
      const timer = setTimeout(
        () => _actions2.default
          .checkCampaignGate({ CampaignKey: campaignKey, MessageTemplate: template, MessageType: messageType })
          .then(result => { if (isCurrent) setChecked({ gate: result, template, hasFailed: false }) })
          .catch(e => {
            log.error(e)
            if (isCurrent) setChecked(c => ({ gate: _nullishCoalesce(_optionalChain([c, 'optionalAccess', _ => _.gate]), () => ( null)), template, hasFailed: true }))
          }),
        GATE_CHECK_DELAY_MS,
      )
      return () => {
        isCurrent = false
        clearTimeout(timer)
      }
    },
    [campaignKey, template, messageType],
  )
  const isCurrent = _optionalChain([checked, 'optionalAccess', _2 => _2.template]) === template
  return { gate: _nullishCoalesce(_optionalChain([checked, 'optionalAccess', _3 => _3.gate]), () => ( null)), isCurrent, hasFailed: isCurrent && !!_optionalChain([checked, 'optionalAccess', _4 => _4.hasFailed]) }
}; exports.useGateCheck = useGateCheck

/* How many unsent recipients have a value for each declared variable. The
 * gate over a template that uses every variable without a fallback counts
 * the recipients missing each one. Null while loading. */
 const useVariableCoverage = (
  campaign,
) => {
  const { CampaignKey, TemplateFields } = campaign
  const [coverage, setCoverage] = _react.useState(null)
  _react.useEffect.call(void 0, 
    () => {
      let isCurrent = true
      if (!TemplateFields.length) {
        setCoverage([])
        return
      }
      _actions2.default
        .checkCampaignGate({ CampaignKey, MessageTemplate: _broadcastTemplateTokens.coverageProbeTemplate.call(void 0, TemplateFields) })
        .then(probe => { if (isCurrent) setCoverage(_broadcastTemplateTokens.variableCoverage.call(void 0, TemplateFields, probe)) })
        .catch(log.error)
      return () => { isCurrent = false }
    },
    [CampaignKey, TemplateFields],
  )
  return coverage
}; exports.useVariableCoverage = useVariableCoverage

/* Enough recipients to preview and search by name; a campaign larger than
 * this previews its first MAX_PREVIEW_RECIPIENTS. */
const MAX_PREVIEW_RECIPIENTS = 1000







/* The campaign's recipients with their values, loaded once `isEnabled`
 * turns on (the first time the preview opens). */
 const usePreviewRecipients = (
  campaignKey,
  isEnabled,
) => {
  const [recipients, setRecipients] = _react.useState(null)
  const shouldLoad = isEnabled && !recipients
  _react.useEffect.call(void 0, 
    () => {
      if (!shouldLoad) return
      let isCurrent = true
      _actions2.default
        .loadCampaignMessages(campaignKey, MAX_PREVIEW_RECIPIENTS)
        .then(r => {
          if (isCurrent) setRecipients({ messages: r.Messages, patients: r.Patients, isComplete: r.isComplete })
        })
        .catch(log.error)
      return () => { isCurrent = false }
    },
    [campaignKey, shouldLoad],
  )
  return recipients
}; exports.usePreviewRecipients = usePreviewRecipients
